import { getParentSegments, IParentSegments } from 'containers/CommentDetails/lib/http';
import _, { cloneDeep } from 'lodash';
import * as React from 'react';
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Dropdown, DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label, ModalHeader,
  Spinner
} from 'reactstrap';
import { Modal, ModalFooter } from '../../components/ui/Modal';
import { ContentCardHeader } from '../../components/ui/ContentCardHeader';
import { DataGrid, DataGridSortOrder } from '../../components/ui/DataGrid';
import { FontAwesomeIcon } from '../../components/ui/FontAwesomeIcon';
import { GridContainer } from '../../components/ui/Grid';
import { Popover } from '../../components/ui/Popover';
import { QuestionsPopover } from '../../components/ui/QuestionsPopover';
import { Tooltip } from '../../components/ui/Tooltip'
import { HttpRequest } from '../../util/http';
import { StatusTypesEndpoint } from '../../util/http/endpoints';
import { IFilters, userData } from '../../util/userData';
import { ICoachingData, ICoachingValue, IResolutionStatus } from '../CoachingFormContainer/interfaces';
import { getActionStatusIcon } from '../CoachingFormContainer/util';
import { IStatusTypes } from '../CoachingFormStatus/interfaces';
import {
  IIndividualSurveysFilters, INormalizedDomain,
} from '../IndividualSurveysDashboardContainer/dashboard/dashboardSlice';
import { getStatus } from '../IndividualSurveysDashboardContainer/utils';
import { openCoachingForm } from './lib/utils';
import DataReportWaitingTimeWarningMessage from "../../shared/Messaging/Warnings/DataReportWaitingTimeWarningMessage";
import { ModalContent } from "../../components/ui/Modal";

interface ICoachingFormsContainerProps {
  coachingData?: ICoachingData
  initialPerfectScoreFilter?: boolean
  initialWowFilter?: boolean
  initialActionItemFilter?: boolean
  initialSalesOpportunity?: boolean
  initialAttritionRisk?: boolean
  records?: ICoachingValue[]
  toggleFilter: (selectedFilter: string) => void
  setSelectedAllIndividualInterviewsIds: () => void
  setSelectedNoneIndividualInterviewsIds: () => void
  resetDataGridFilters: () => void
  toggleSelectedCoachingForm: (record: ICoachingValue) => void
  updateStatusFilter: (statusFilterId: number) => void
  markAsRead: (record: ICoachingValue) => void
  toggleWow: (record: ICoachingValue) => void
  toggleIsSalesOpportunity: (record: ICoachingValue) => void
  updateStatusSection: () => void
  toggleIndividualSurveyAsActionItem: (record: ICoachingValue) => void
  statusTypes: INormalizedDomain<any>
  statusTypesList: IStatusTypes[]
  statuses: any
  actionAlertAttachedStatus: any
  individualSurveysFilters: IIndividualSurveysFilters
  individualSurveysStatusFilter: number[];
  selectedCoachingFormIds: number[];
  isLoading: boolean;
  filtersForQuestionsReady: boolean
  filtersForQuestionsPopup: IFilters
  deleteIndividualSurveysSelection: () => void
}

interface ICoachingFormsContainerState {
  localStateRecords: ICoachingValue[]
  sortBy: keyof ICoachingValue
  sortOrder: DataGridSortOrder
  statusTypes: IStatusTypes[]
  statuses: IResolutionStatus[]
  selectedCoachingFormIds: Array<ICoachingValue['id']>
  actionItemFilter: boolean
  wowFilter: boolean
  perfectScoreFilter: boolean
  salesOpportunityFilter: boolean
  attritionRiskFilter: boolean
  hiddenProperties: Array<keyof ICoachingValue>
  readFilter?: boolean
  notesFilter?: boolean
  statusFilter?: number[]
  segmentFields: IParentSegments[]
  hiddenSegments: IParentSegments[]
  hasNotesAccess?: boolean
  actionAlertAttachedStatus?: any
  flagFilter?: boolean
  hasFlagAccess?: boolean
  canExport?: boolean
  exportLoaded?: boolean
  individualSurveysActionsDropdownOpen: boolean
  individualSurveysDeleteInProgress: boolean
  individualSurveysDeleteConfirmationModalOpen: boolean,
  individualSurveysDeleteConfirmationModalEnableDeleteButton: boolean,
  individualSurveysDeleteConfirmationText: string
  individualSurveysDeletePermission: boolean
}

export class CoachingFormsContainer extends React.Component<ICoachingFormsContainerProps, ICoachingFormsContainerState> {
  static CoachingFormsContainerColumnsKey = 'CoachingFormsContainerColumnsKey';
  static CoachingFormsContainerSegmentsKey = 'CoachingFormsContainerSegmentsKey';

  state: ICoachingFormsContainerState = {
    sortBy: 'interviewDate',
    sortOrder: 'asc',
    localStateRecords: [],
    statusTypes: [],
    statuses: [],
    selectedCoachingFormIds: [],
    hiddenProperties: ['parentLabel'],
    actionItemFilter: false,
    wowFilter: false,
    perfectScoreFilter: false,
    salesOpportunityFilter: false,
    attritionRiskFilter: false,
    hasNotesAccess: false,
    segmentFields: [],
    hiddenSegments: [],
    hasFlagAccess: false,
    canExport: false,
    exportLoaded: true,
    individualSurveysActionsDropdownOpen: false,
    individualSurveysDeleteInProgress: false,
    individualSurveysDeleteConfirmationModalOpen: false,
    individualSurveysDeleteConfirmationModalEnableDeleteButton: false,
    individualSurveysDeleteConfirmationText: '',
    individualSurveysDeletePermission: false,
  }

  hasInitiatedDefaults = false
  childPopupListener = (msgEv: MessageEvent) => this.listenForChildPopupMessages(msgEv)

  componentWillMount() {
    // this.loadStatuses()
    this.loadDefaults()
    this.loadAndFilterRows()
    this.setCachedColumnsIfExists()
    this.updateParentSegments()
    this.loadNotesPermission()
    this.loadFlagPermission()
    this.loadExportAccess()
    this.loadIndividualSurveysDelete()
    // this.getCoachingFormsIds()

    window.addEventListener('message', this.childPopupListener)
  }

  componentWillReceiveProps(nextProps: ICoachingFormsContainerProps) {
    this.loadAndFilterRows(nextProps)
    // this.getCoachingFormsIds(nextProps)

  }

  componentWillUnmount() {
    window.removeEventListener('message', this.childPopupListener);
  }

  loadNotesPermission() {
    HttpRequest.fetch<{ hasNotesAccess: boolean }>('/scripts/clients/get_notes_permission').then((resp) => this.setState({ hasNotesAccess: resp.hasNotesAccess }))
  }

  loadFlagPermission() {
    HttpRequest.fetch<{ hasFlagAccess: boolean }>('/scripts/clients/get_flag_permission').then((resp) => this.setState({ hasFlagAccess: resp.hasFlagAccess }))
  }

  loadExportAccess() {
    HttpRequest.fetch<{ canExport: boolean }>('/scripts/coaching_forms/get_export_permission').then((resp) => this.setState({ canExport: resp.canExport }))
  }

  loadIndividualSurveysDelete() {
    // @ts-ignore
    HttpRequest.fetch<{ permissionResponse: any }>('/web/v1/individual-surveys-delete-permission', { method: 'POST' }).then((resp) => this.setState({ individualSurveysDeletePermission: resp.data.hasDeleteSurveyAccess }))
  }

  exportSelectedSurveyCSV(props = this.props) {
    if (this.state.exportLoaded) {
      const { selectedCoachingFormIds } = this.props
      const idsJson = JSON.stringify(selectedCoachingFormIds);
      const abbr = props.coachingData.survey
      this.setState({ exportLoaded: false });
      const filename = 'individual_surveys_' + new Date().toJSON().slice(0, 10) + '.csv'
      $.ajax({
        url: '/scripts/coaching_forms/get_selected_surveys_csv',
        data: { abbr, idsJson },
        type: 'post',
        dataType: 'json',
        // tslint:disable-next-line:unnecessary-bind
        success: function (data) {
          const csvContent = data
          const link = window.document.createElement('a');
          link.setAttribute('href', 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csvContent));
          link.setAttribute('download', filename);
          link.click();
          this.setState({ exportLoaded: true })
        }.bind(this)
      })
    }
  }

  setCachedColumnsIfExists() {
    const columnsStr = localStorage.getItem(CoachingFormsContainer.CoachingFormsContainerColumnsKey)
    const segmentStr = localStorage.getItem(CoachingFormsContainer.CoachingFormsContainerSegmentsKey)

    try {
      const columns: Array<keyof ICoachingValue> = JSON.parse(columnsStr)

      if (columns instanceof Array) {
        this.setState({ hiddenProperties: columns });
      }

    } catch { /* */
    }

    try {
      const segmentColumns = JSON.parse(segmentStr)

      if (segmentColumns instanceof Array) {
        this.setState({ hiddenSegments: segmentColumns });
      }

    } catch { /* */
    }
  }

  updateParentSegments() {
    getParentSegments().then((segmentFields) => {
      this.setState({ segmentFields })
    })
  }

  loadDefaults(props = this.props) {
    if (!this.hasInitiatedDefaults) {
      const {
        initialActionItemFilter,
        initialWowFilter,
        initialPerfectScoreFilter,
        initialSalesOpportunity,
        initialAttritionRisk
      } = props;

      this.hasInitiatedDefaults = (
        typeof initialActionItemFilter === 'boolean' ||
        typeof initialWowFilter === 'boolean' ||
        typeof initialSalesOpportunity === 'boolean' ||
        typeof initialPerfectScoreFilter === 'boolean' ||
        typeof initialAttritionRisk === 'boolean'
      )

      const actionItemFilter = typeof initialActionItemFilter === 'boolean' && initialActionItemFilter
      const wowFilter = typeof initialWowFilter === 'boolean' && initialWowFilter
      const perfectScoreFilter = typeof initialPerfectScoreFilter === 'boolean' && initialPerfectScoreFilter
      const salesOpportunityFilter = typeof initialSalesOpportunity === 'boolean' && initialSalesOpportunity
      const attritionRiskFilter = typeof initialAttritionRisk === 'boolean' && initialAttritionRisk

      this.setState({ actionItemFilter, wowFilter, perfectScoreFilter, salesOpportunityFilter, attritionRiskFilter },
        () => this.loadAndFilterRows(props))

    }
  }

  loadAndFilterRows(props = this.props) {
    const { coachingData, actionAlertAttachedStatus, statusTypes, statuses } = props;
    const {
      actionItemFilter,
      readFilter,
      notesFilter,
      perfectScoreFilter,
      statusFilter,
      wowFilter,
      salesOpportunityFilter,
      attritionRiskFilter,
      flagFilter
    } = this.state
    const propRecords = coachingData ? coachingData.values : []
    const newRecords = propRecords.filter((v) => {
      const status = Number(getStatus(v, actionAlertAttachedStatus, statusTypes, statuses))
      const isRead = v.viewed.toLowerCase() === 'yes'
      const isActionItem = v.ai === '1'
      const hasWow = v.wow === '1'
      const hasPerfectScore = v.ps === '1'
      const isSalesOpportunity = v.is_sales_opportunity === 1;
      const isAttritionRisk = v.is_attrition_risk === 1;
      const hasComments = v.hasComments;
      const isFlagged = v.is_flagged;

      if (typeof readFilter === 'boolean' && readFilter !== isRead) {
        return false
      }

      if (typeof notesFilter === 'boolean' && notesFilter !== hasComments) {
        return false
      }

      if (typeof flagFilter === 'boolean' && flagFilter !== isFlagged) {
        return false
      }

      if (actionItemFilter && !isActionItem) {
        return false
      }

      if (wowFilter && !hasWow) {
        return false
      }

      if (perfectScoreFilter && !hasPerfectScore) {
        return false
      }

      if (statusFilter !== undefined && status !== undefined && statusFilter.indexOf(status) === -1) {
        return false
      }

      if (salesOpportunityFilter && !isSalesOpportunity) {
        return false
      }

      return !(attritionRiskFilter && !isAttritionRisk);

    })

    this.setState({ localStateRecords: newRecords })
  }

  loadStatuses() {
    HttpRequest.fetch<IStatusTypes[]>(StatusTypesEndpoint)
      .then((statusTypes) => this.setState({ statusTypes }))

    HttpRequest.fetch<IResolutionStatus[]>('/scripts/coaching_form/status_get_all')
      .then((statuses) => this.setState({ statuses }))
  }

  listenForChildPopupMessages(msgEvent: MessageEvent) {
    const localStateRecords = _.cloneDeep(this.props.records);
    if (msgEvent.data === 'refreshStatusSection') {
      this.props.updateStatusSection();
    }
    if (typeof msgEvent.data.indexOf === 'function' && msgEvent.data.indexOf('updateActionAlert') > -1) {
      const pcs = msgEvent.data.split('#');
      const id = pcs[1];
      const newAi = pcs[2];
      if (localStateRecords.length > 0) {
        const values = localStateRecords;
        const value = values.find((s) => s.id.toString() === id)
        const valueIndex = values.findIndex((s) => s.id.toString() === id)
        if (typeof value === 'object') {
          value.ai = String(newAi)
          value.status = newAi
          values[valueIndex] = value
          this.props.toggleIndividualSurveyAsActionItem(value);
        }
      }
    }
    if (typeof msgEvent.data.indexOf === 'function' && msgEvent.data.indexOf('updateHasNotes') > -1) {
      const eventData = JSON.parse(msgEvent.data);
      const externalDataReference = parseInt(eventData.edr, 10)
      const recordIndex = this.state.localStateRecords.findIndex((value) => {
        return value.id === externalDataReference
      })

      localStateRecords[recordIndex].hasComments = true
      this.setState({ localStateRecords });
      /// removed because it was changing the star every time.
      //this.props.toggleWow(localStateRecords[recordIndex]);
    }

    if (typeof msgEvent.data.indexOf === 'function' && msgEvent.data.indexOf('updateHasSalesOpportunity') > -1) {
      const eventData = JSON.parse(msgEvent.data);
      const externalDataReference = parseInt(eventData.edr, 10)
      const recordIndex = this.state.localStateRecords.findIndex((value) => {
        return value.id === externalDataReference
      })

      localStateRecords[recordIndex].hasComments = true
      this.setState({ localStateRecords });
      this.props.toggleIsSalesOpportunity(localStateRecords[recordIndex]);
    }

    if (typeof msgEvent.data.indexOf === 'function' && msgEvent.data.indexOf('updateWowItem') > -1) {
      const eventData = JSON.parse(msgEvent.data);
      const externalDataReference = parseInt(eventData.edr, 10)
      const recordIndex = this.state.localStateRecords.findIndex((value) => {
        return value.id === externalDataReference
      })

      localStateRecords[recordIndex].hasComments = true
      this.setState({ localStateRecords });
      this.props.toggleWow(localStateRecords[recordIndex]);
    }
  }

  renderViewedColumn(record: ICoachingValue) {
    const text = record.viewed === 'Yes' ? 'Read' : 'Unread'
    const isMuted = record.viewed === 'Yes'

    return (
      <Tooltip position='right' text={text}>
        <FontAwesomeIcon icon="bookmark" verticalAlign="initial" muted={isMuted} fixedWidth />
      </Tooltip>
    )
  }

  renderIdColumn(record: ICoachingValue) {
    const { hasNotesAccess } = this.state
    return (
      <span className="link" onClick={() => {
        this.openCoachingForm(record)
      }}>
        <FontAwesomeIcon icon="search" verticalAlign="initial" size="md" />
        <span>&nbsp;{record.id}</span>
        <span>
          &nbsp;{(hasNotesAccess && record.hasComments) ?
            <FontAwesomeIcon icon="circle" color="orange" verticalAlign="initial" size="md"
              style={{ fontSize: 'small' }} /> : null}
        </span>
        {/* Shows if survey is flagged by user*/}
        <span>
          &nbsp;{(record.is_flagged) ? <FontAwesomeIcon icon="flag" color="purple" verticalAlign="initial" size="md"
            style={{ fontSize: 'small' }} /> : null}
        </span>
      </span>
    )
  }

  renderStatusColumn(record: ICoachingValue) {
    const statusName = getStatus(
      record,
      this.props.actionAlertAttachedStatus,
      this.props.statusTypes,
      this.props.statuses,
      true
    ).toString();
    const isActionItem = record.ai === '1' || this.props.actionAlertAttachedStatus.hasOwnProperty(record.id.toString())
    const isWow = record.wow === '1'
    const isPerfectScore = record.ps === '1'
    const isSalesOpportunity = record.is_sales_opportunity === 1;
    const isAttritionRisk = record.is_attrition_risk === 1;

    return (
      <article>
        <Tooltip text={isActionItem ? 'Action Item' : 'Not an Action Item'}>
          <FontAwesomeIcon icon="exclamation-triangle" color="orange" muted={!isActionItem} />
        </Tooltip>
        <Tooltip text={isSalesOpportunity ? 'Sales Opportunity' : 'Not a Sales Opportunity'}>
          <FontAwesomeIcon icon="dollar-sign" color="green" muted={!isSalesOpportunity} />
        </Tooltip>
        <Tooltip text={isAttritionRisk ? 'Attrition Risk' : 'Not an Attrition Risk'}>
          <FontAwesomeIcon icon="asterisk" color="red" muted={!isAttritionRisk} />
        </Tooltip>
        <Tooltip text={isWow ? 'WOW' : 'No WOW'}>
          <FontAwesomeIcon icon="star" color="yellow" muted={!isWow} />
        </Tooltip>
        <Tooltip text={isPerfectScore ? 'Perfect Score' : 'Not a Perfect Score'}>
          <FontAwesomeIcon icon="check" color="green" muted={!isPerfectScore} />
        </Tooltip>
        <Tooltip text={statusName}>
          {getActionStatusIcon(statusName)}
        </Tooltip>
      </article>
    )
  }

  renderBulkCheck(record: ICoachingValue) {
    const disableActions = false
    const isSelected = this.isSelected(record)
    const isNotSelected = !isSelected
    const icon = isSelected ? 'check-square' : 'square'
    const className = (isNotSelected || disableActions) ? 'text-dark' : ''
    const iconElement = (
      <FontAwesomeIcon className={className}
        verticalAlign="initial"
        icon={icon}
        regular={isNotSelected && !disableActions} />
    )

    if (disableActions) {
      return (<span>{iconElement}</span>)
    }

    return (
      <span className="link" onClick={() => this.props.toggleSelectedCoachingForm(record)}>
        {iconElement}
      </span>
    )
  }

  selectNoneForCoachingForms() {
    this.setState({ selectedCoachingFormIds: [] })
  }

  isSelected(record: ICoachingValue) {
    const { selectedCoachingFormIds } = this.props
    const selectedIndex = selectedCoachingFormIds.indexOf(record.id)

    return selectedIndex >= 0
  }

  openCoachingForm(record: ICoachingValue) {
    const { abbr_survey, id, ai, canFlag, is_flagged, isCommentHidden, userCanHideComment } = record
    openCoachingForm(id, { ai, abbr_survey, canFlag, is_flagged, isCommentHidden, userCanHideComment })
    this.props.markAsRead(record)
  }

  markCoachingFormAsRead(record: ICoachingValue) {
    const { localStateRecords } = this.state

    if (localStateRecords.length > 0) {
      record.viewed = 'Yes'
      const recordIndex = localStateRecords.findIndex((v) => v.id === record.id)

      if (recordIndex >= 0) {
        localStateRecords[recordIndex] = record
        this.setState(this.state)
      }
    }
  }

  exportSelected() {
    const { selectedCoachingFormIds, records } = this.props

    if (records.length <= 0) {
      return
    }

    const selectedSurveys = selectedCoachingFormIds.map((id) => {
      const value = records.find((v) => v.id === id)
      if (value !== undefined) {
        const { abbr_survey } = value

        // this.markCoachingFormAsRead(value) //fixme

        return { abbr_survey, id }
      }
    })

    localStorage.setItem('selectedSurveys', JSON.stringify(selectedSurveys))
    const page = 'coaching_form?back=co&loadSelectedSurveys=true'
    window.open(page, '', 'width=800,height=800,scrollbars=1,resizable=1')

    setTimeout(() => this.selectNoneForCoachingForms(), 1000)
  }

  unreadFilterClicked() {
    const { toggleFilter } = this.props
    toggleFilter('unReadFilter');
  }

  readFilterClicked() {
    const { toggleFilter } = this.props
    toggleFilter('readFilter');
  }

  notesFilterClicked() {
    const { toggleFilter } = this.props
    toggleFilter('notesFilter');
  }

  flagFilterClicked() {
    const { toggleFilter } = this.props
    toggleFilter('flagFilter');
  }

  toggleActionItemFilter(actionItemFilter = !this.state.actionItemFilter) {
    const { toggleFilter } = this.props
    toggleFilter('actionItemFilter');

    if (!actionItemFilter) {
      // Remove status filter when actionItemFilter has been turned off
      const statusFilter = undefined
      this.state.statusFilter = statusFilter
      this.setState({ statusFilter })
    }

  }

  toggleWowFilter() {
    const { toggleFilter } = this.props
    toggleFilter('wowFilter');
  }

  togglePerfectScoreFilter() {
    const { toggleFilter } = this.props
    toggleFilter('perfectScoreFilter');
  }

  toggleSalesOpportunityFilter() {
    const { toggleFilter } = this.props
    toggleFilter('salesOpportunityFilter');
  }

  toggleAttritionRiskFilter() {
    const { toggleFilter } = this.props
    toggleFilter('attritionRiskFilter');
  }

  isHiddenSegment(prop: string) {
    const parentSegment = this.state.hiddenSegments.find((current) => {
      return current.avid === prop
    })

    return parentSegment === undefined
  }

  toggleHiddenSegment(prop: IParentSegments) {
    const { hiddenSegments } = this.state
    const indexOfProp = hiddenSegments.map((segment) => segment.avid).indexOf(prop.avid)

    if (indexOfProp >= 0) {
      hiddenSegments.splice(indexOfProp, 1)
    } else {
      hiddenSegments.push(prop)
    }

    this.setState({ hiddenSegments })
    this.saveCachedSegments(hiddenSegments)
  }

  saveCachedSegments(segments) {
    const segmentsStr = JSON.stringify(segments)

    localStorage.setItem(CoachingFormsContainer.CoachingFormsContainerSegmentsKey, segmentsStr)
  }

  resetFilterAndSortState() {
    this.props.resetDataGridFilters();
    this.setState({
      sortOrder: 'asc',
      sortBy: 'interviewDate',
      actionItemFilter: false,
      wowFilter: false,
      perfectScoreFilter: false,
      readFilter: undefined,
      notesFilter: undefined,
      flagFilter: undefined,
      salesOpportunityFilter: false,
      attritionRiskFilter: false,
      statusFilter: undefined
    },
      () => this.loadAndFilterRows())
  }

  isHiddenColumn(prop: keyof ICoachingValue) {
    return this.state.hiddenProperties.indexOf(prop) >= 0
  }

  toggleHiddenColumn(prop: keyof ICoachingValue) {
    const { hiddenProperties } = this.state
    const indexOfProp = hiddenProperties.indexOf(prop)

    if (indexOfProp >= 0) {
      hiddenProperties.splice(indexOfProp, 1)
    } else {
      hiddenProperties.push(prop)
    }

    this.setState({ hiddenProperties })
    this.saveCachedColumns(hiddenProperties)
  }

  saveCachedColumns(columns: Array<keyof ICoachingValue>) {
    const columnsStr = JSON.stringify(columns)

    localStorage.setItem(CoachingFormsContainer.CoachingFormsContainerColumnsKey, columnsStr)
  }

  getCoachingFormsIds(props = this.props) {
    const { coachingData } = props;
    const propRecords: ICoachingValue[] = coachingData ? coachingData.values : []
    const ids = propRecords.reduce((acc, curr) => {
      return acc.concat(curr.id);
    }, [])
    const method = 'POST';
    const data = { current_project: userData.getCurrentProject(), coachingFormsIds: ids.join(',') };
    if (ids.length > 0) {
      HttpRequest.fetch('/scripts/coaching_forms/get_attached_alerts_status', { data, method }).then((res) => {
        this.setState({ actionAlertAttachedStatus: res });
        const updatedRecords = this.state.localStateRecords.map((record) => {
          const updatedRecord = cloneDeep(record);
          if (res.hasOwnProperty(record.id)) {
            updatedRecord.ai = '1';
          }
          return updatedRecord;
        });
        this.setState({ localStateRecords: updatedRecords });
      })
    }
  }

  deleteSelectedSurveys = () => {
    const { selectedCoachingFormIds } = this.props
    const external_data_references = selectedCoachingFormIds.join(',');
    HttpRequest.fetch('/web/v1/delete-surveys', {
      method: 'POST',
      data: {
        external_data_references,
        client: userData.getCurrentProject(),
      }
    })
      .then((response: any) => {
        if (response.data.success) {
          this.props.deleteIndividualSurveysSelection();
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          throw new Error('You do not have permission to delete these surveys.');
        } else {
          throw new Error('An error occurred while deleting the surveys.');
        }
      })
      .finally(() => {
        this.setState({
          individualSurveysDeleteInProgress: false,
          individualSurveysDeleteConfirmationModalOpen: false,
          individualSurveysDeleteConfirmationModalEnableDeleteButton: false,
          individualSurveysDeleteConfirmationText: '',
        }, () => {
          $('.sticky-top').css({ 'z-index': '1020' });
        });
      })
  }


  // noinspection SpellCheckingInspection
  render() {
    const { hasFlagAccess, canExport, exportLoaded, hasNotesAccess } = this.state
    const {
      actionItemFilter,
      wowFilter,
      readFilter,
      notesFilter,
      perfectScoreFilter,
      salesOpportunityFilter,
      attritionRiskFilter,
      flagFilter,
      unReadFilter
    } = this.props.individualSurveysFilters
    const { selectedCoachingFormIds, individualSurveysStatusFilter } = this.props;
    const localStateRecords = this.props.records || [];
    const { segmentFields } = this.state
    const { coachingData } = this.props
    const recordsLength = localStateRecords.length
    const selectedLength = selectedCoachingFormIds.length
    const shouldDisableBulkSelectAll = selectedLength === recordsLength
    const noneSelected = selectedLength <= 0
    const { isLoading } = this.props;
    const loading = isLoading;
    const hasData = !loading && recordsLength > 0
    const hasNoData = !loading && recordsLength <= 0
    const coachingDataStat = coachingData ? [coachingData.stat] : []
    const coachingDataQ = coachingData ? coachingData.q : ''
    const coachingDataQuestion = coachingData ? coachingData.question : ''
    const notesFilterOn = notesFilter === true
    const flagFilterOn = flagFilter === true

    let isOpen = false;
    if (userData && userData.getFilters() && Array.isArray(userData.getFilters().period)) {
      isOpen = loading && userData.getFilters().period.includes('YTD');
    }

    let deleteButtonText = this.state.individualSurveysDeleteInProgress ? 'Deleting' : 'Delete';
    return (
      <>
        <Modal open={this.state.individualSurveysDeleteConfirmationModalOpen}
          position="relative"
        >
          <ModalContent>
            <header>
              <p style={{ fontSize: '1.2rem' }}>You are about to delete {selectedLength} {selectedLength > 1 ? 'surveys' : 'survey'}. This action cannot be
                undone. Please type the word "DELETE" below in order to confirm you
                would like these surveys, and their associated notes and alerts will be
                permanently removed from the application.</p>
            </header>
            <section>
              <Input type="text" placeholder="Type DELETE to confirm"
                value={this.state.individualSurveysDeleteConfirmationText}
                onChange={(e) => {
                  this.setState({ individualSurveysDeleteConfirmationText: e.target.value });
                  if (e.target.value.toUpperCase() === 'DELETE') {
                    this.setState({ individualSurveysDeleteConfirmationModalEnableDeleteButton: true });
                  } else {
                    this.setState({ individualSurveysDeleteConfirmationModalEnableDeleteButton: false });
                  }
                }} />
            </section>
          </ModalContent>
          <ModalFooter>
            <div className="blacklight">
              <Button disabled={!this.state.individualSurveysDeleteConfirmationModalEnableDeleteButton}
                color="danger" onClick={() => this.deleteSelectedSurveys()}>{deleteButtonText}</Button>
              <Button color="secondary"
                onClick={() => this.setState({ individualSurveysDeleteConfirmationModalOpen: false })}>Cancel</Button>
            </div>
          </ModalFooter>
        </Modal>
        <section className="blacklight page-container">
          <GridContainer>
            <Card>
              <ContentCardHeader
                sticky
                borderBottom
                header={
                  <section className="d-md-flex justify-content-between">
                    <article>
                      <span>Individual Surveys</span>
                      {loading &&
                        <FontAwesomeIcon icon="cog" size="sm" verticalAlign="middle" spin muted />
                      }
                      {!noneSelected &&
                        <small>:&nbsp;{selectedLength.toLocaleString()}&nbsp;selected</small>
                      }
                    </article>
                    <div style={{ maxWidth: '45%' }}>
                      <DataReportWaitingTimeWarningMessage
                        isOpen={isOpen}
                        selectedOption={"annual"}
                      />
                    </div>
                    <article>
                      <Button className="pr-0 pl-0" color="link" href="Edit Status.pdf" target="_blank">
                        <FontAwesomeIcon icon="question-circle" verticalAlign="initial" size="md" />
                        <span>&nbsp;Help</span>
                      </Button>
                    </article>
                  </section>
                }
                headerActions={
                  <section className="mt-2 d-md-flex justify-content-between">
                    <article className="d-flex">
                      <Popover btnText="Actions" className="mr-2" popoverClassName="bg-white">
                        <div>
                          <button type="button" disabled className="disabled dropdown-item">
                            <p className="m-0">AI Analysis</p>
                          </button>
                          {this.state.individualSurveysDeletePermission &&
                            <button type="button" disabled={noneSelected}
                              className={noneSelected ? "disabled dropdown-item" : "dropdown-item"}
                              onClick={() => {
                                this.setState({ individualSurveysDeleteConfirmationModalOpen: true }, () => {
                                  $('.sticky-top').css({ 'z-index': '999' });
                                });
                              }}>
                              {this.state.individualSurveysDeleteInProgress ?
                                <p className="m-0">Deleting <Spinner color="black"
                                  style={{
                                    width: '1.2rem',
                                    height: '1.2rem'
                                  }} />
                                </p> :
                                <p className="m-0">Delete</p>
                              }
                            </button>
                          }
                          {canExport &&
                            <button type="button" disabled={noneSelected}
                              className={noneSelected ? "disabled dropdown-item" : "dropdown-item"}
                              onClick={() => this.exportSelectedSurveyCSV()}
                            >
                              {exportLoaded ? <span>Export (CSV)</span> :
                                <span>Exporting (CSV) <Spinner color="black" style={{
                                  width: '1.2rem',
                                  height: '1.2rem'
                                }} /></span>}
                            </button>
                          }
                          <button type="button" disabled={noneSelected}
                            className={noneSelected ? "disabled dropdown-item" : "dropdown-item"}
                            onClick={() => this.exportSelected()}>
                            <p className="m-0">Export (PDF)</p></button>
                        </div>
                      </Popover>
                      <Button className="mr-2" color="primary"
                        disabled={shouldDisableBulkSelectAll}
                        onClick={() => this.props.setSelectedAllIndividualInterviewsIds()}>
                        Select All
                      </Button>
                      <Button className="mr-2" color="primary"
                        disabled={noneSelected}
                        onClick={() => this.props.setSelectedNoneIndividualInterviewsIds()}>
                        Clear Selection
                      </Button>
                    </article>
                    <article className="d-md-flex justify-content-end">
                      <Popover btnText="Fields" className="mr-3">
                        <section style={{ fontSize: '1rem', minWidth: 150, maxHeight: '250px', overflowY: 'scroll' }}>
                          <FormGroup check>
                            <Label>
                              <Input type="checkbox" checked={!this.isHiddenColumn('interviewDate')}
                                onChange={() => this.toggleHiddenColumn('interviewDate')} />
                              <span>&nbsp;Date</span>
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label>
                              <Input type="checkbox" checked={!this.isHiddenColumn('organization')}
                                onChange={() => this.toggleHiddenColumn('organization')} />
                              <span>&nbsp;Team</span>
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label>
                              <Input id='parentLabel' type="checkbox" checked={!this.isHiddenColumn('parentLabel')}
                                onChange={() => this.toggleHiddenColumn('parentLabel')} />
                              <span>&nbsp;Org Parent</span>
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label>
                              <Input type="checkbox" checked={!this.isHiddenColumn('survey')}
                                onChange={() => this.toggleHiddenColumn('survey')} />
                              <span>&nbsp;Survey</span>
                            </Label>
                          </FormGroup>
                          <FormGroup check>
                            <Label>
                              <Input type="checkbox" checked={!this.isHiddenColumn('response')}
                                onChange={() => this.toggleHiddenColumn('response')} />
                              <span>&nbsp;{coachingDataQuestion}</span>
                            </Label>
                          </FormGroup>
                          <section>
                            <span style={{ fontWeight: 'bold', textDecoration: 'underline' }}>Segments</span>
                            {segmentFields.map((field) => {
                              return (
                                <FormGroup check key={field.avid}>
                                  <Label>
                                    <Input type="checkbox" checked={!this.isHiddenSegment(field.avid)}
                                      onChange={() => this.toggleHiddenSegment(field)} />
                                    <span>&nbsp;{field.label}</span>
                                  </Label>
                                </FormGroup>
                              )
                            })}
                          </section>
                        </section>
                      </Popover>
                      {this.props.filtersForQuestionsReady &&
                        <QuestionsPopover<true> filtersObject={this.props.filtersForQuestionsPopup} multi
                          questionId={coachingDataQ} statId={coachingDataStat}
                          dataUrl="get_categories" />
                      }
                      <Popover className="ml-3" btnText="Action Filters" maxWidth={true}>
                        <section className="d-flex justify-content-between">
                          <ButtonGroup className="mb-3">
                            <Button color="white" active={unReadFilter} onClick={() => this.unreadFilterClicked()}>
                              <FontAwesomeIcon icon="bookmark" fixedWidth />
                              <span>&nbsp;Unread</span>
                            </Button>
                            <Button color="white" active={readFilter} onClick={() => this.readFilterClicked()}>
                              <FontAwesomeIcon icon="bookmark" fixedWidth muted />
                              <span>&nbsp;Read</span>
                            </Button>
                            {hasNotesAccess &&
                              <Button color="white" active={notesFilterOn}
                                onClick={() => this.notesFilterClicked()}>
                                <FontAwesomeIcon icon="circle" color="orange" verticalAlign="initial" size="md"
                                  style={{ fontSize: 'small' }} />
                                <span>&nbsp;Notes</span>
                              </Button>
                            }

                            {hasFlagAccess &&
                              <Button color="white" active={flagFilterOn}
                                onClick={() => this.flagFilterClicked()}>
                                <FontAwesomeIcon icon="flag" color="purple" verticalAlign="initial" size="md"
                                  style={{ fontSize: 'small' }} />
                                <span>&nbsp;Flagged</span>
                              </Button>
                            }

                          </ButtonGroup>
                          <ButtonGroup className="mb-3 ml-3">
                            <Button color="white" id="resetFilterBtns"
                              onClick={() => this.resetFilterAndSortState()}>
                              <FontAwesomeIcon icon="ban" fixedWidth style={{ color: 'red' }} />
                              <span>&nbsp;Reset Action Filters</span>
                            </Button>
                          </ButtonGroup>
                        </section>
                        <ButtonGroup className="mb-3">
                          <Button color="white" active={actionItemFilter}
                            onClick={() => this.toggleActionItemFilter()}>
                            <FontAwesomeIcon icon="exclamation-triangle" color="orange" fixedWidth />
                            <span>&nbsp;Action Alert</span>
                          </Button>
                          <Button color="white" active={salesOpportunityFilter}
                            onClick={() => this.toggleSalesOpportunityFilter()}>
                            <FontAwesomeIcon icon="dollar-sign" color="green" fixedWidth />
                            <span>&nbsp;Sales Opportunity</span>
                          </Button>
                          <Button color="white" active={attritionRiskFilter}
                            onClick={() => this.toggleAttritionRiskFilter()}>
                            <FontAwesomeIcon icon="asterisk" color="red" fixedWidth />
                            <span>&nbsp;Attrition Risk</span>
                          </Button>
                          <Button color="white" active={wowFilter} onClick={() => this.toggleWowFilter()}>
                            <FontAwesomeIcon icon="star" color="yellow" fixedWidth />
                            <span>&nbsp;WOW</span>
                          </Button>
                          <Button color="white" active={perfectScoreFilter}
                            onClick={() => this.togglePerfectScoreFilter()}>
                            <FontAwesomeIcon icon="check" color="green" fixedWidth />
                            <span>&nbsp;Perfect Score</span>
                          </Button>
                        </ButtonGroup>
                        <ButtonGroup className="mb-3">
                          {this.props.statusTypesList.map((statusType) =>
                            <Button color="white" key={statusType.id}
                              active={individualSurveysStatusFilter.includes(statusType.id)}
                              onClick={() => {
                                this.props.updateStatusFilter(statusType.id)
                              }
                              }
                            >
                              {getActionStatusIcon(statusType.status)}
                              <span>&nbsp;{statusType.status}</span>
                            </Button>
                          )}
                        </ButtonGroup>
                      </Popover>
                    </article>
                  </section>
                }
              />
              {hasNoData &&
                <Alert color="warning" className="animated fadeIn">
                  <FontAwesomeIcon icon="sticky-note" verticalAlign="initial" size="md" />
                  <span>&nbsp;No data found for the current filters.</span>
                </Alert>
              }
              {hasData &&
                <DataGrid<ICoachingValue>
                  className="animated fadeIn"
                  sortBy={this.state.sortBy}
                  sortOrder={this.state.sortOrder}
                  onSortChange={(sortBy, sortOrder) => this.setState({ sortBy, sortOrder })}
                  records={localStateRecords}
                  columns={[
                    { header: '', sortable: false, width: 55, render: (record) => this.renderViewedColumn(record) },
                    {
                      header: 'Bulk',
                      align: 'center',
                      width: 55,
                      sortable: false,
                      render: (avid) => this.renderBulkCheck(avid)
                    },
                    {
                      header: 'ID',
                      property: 'id',
                      hidden: this.isHiddenColumn('id'),
                      render: (record) => this.renderIdColumn(record)
                    },
                    { property: 'interviewDate', header: 'Date', hidden: this.isHiddenColumn('interviewDate') },
                    { property: 'organization', header: 'Team', hidden: this.isHiddenColumn('organization') },
                    { property: 'parentLabel', header: 'Org Parent', hidden: this.isHiddenColumn('parentLabel') },
                    { property: 'survey', header: 'Survey', hidden: this.isHiddenColumn('survey') },
                    { property: 'response', header: coachingDataQuestion, hidden: this.isHiddenColumn('response') },
                    {
                      property: 'segments',
                      header: 'Segments',
                      sortable: false,
                      hidden: this.state.hiddenSegments.length === 0,
                      render: (record) => {
                        return (
                          < section style={{ fontSize: '12px' }}>
                            {
                              record.segments.map((segment) => {
                                if (!this.isHiddenSegment(segment.columnValue)) {
                                  return <section key={segment.columnValue + segment.value}>
                                    <b>{segment.columnHeader}:</b>&nbsp;{segment.value}</section>
                                }
                              })
                            }
                          </section>
                        )
                      }
                    },
                    { header: 'Statuses', render: (record) => this.renderStatusColumn(record) }
                  ]} />
              }
            </Card>
          </GridContainer>
        </section>
      </>
    )
  }
}
